import { CSPUrlsMap } from './CSPUrlsMap';

export const CSPMobileMenuStructure = (isLiveVetEnabled, isPayNowEnabled) => [
  {
    label: 'Dashboard',
    hideLabel: false,
    isReactRouterLink: true,
    url: CSPUrlsMap.dashboard.url
  },
  {
    label: 'Live vet',
    customCssClass: 'liveVetMenuItem',
    hideLabel: false,
    isReactRouterLink: true,
    hideItem: !isLiveVetEnabled,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.liveVet.url
  },
  {
    label: 'Claims',
    hideLabel: false,
    icons: {
      right: {
        open: 'caret_up',
        closed: 'caret_down'
      }
    },
    menuItems: [
      {
        label: 'My claims',
        hideLabel: false,
        isReactRouterLink: true,
        url: CSPUrlsMap.myClaims.url
      },
      {
        icons: {
          left: 'claim-new'
        },
        label: 'Make a new claim',
        hideLabel: false,
        isReactRouterLink: true,
        url: CSPUrlsMap.newClaim.url
      }
    ]
  },
  {
    label: 'My pets',
    hideLabel: false,
    isReactRouterLink: true,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.myPets.url
  },
  {
    label: 'My documents',
    hideLabel: false,
    isReactRouterLink: true,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.myDocuments.url
  },
  {
    label: 'Premiums & payments',
    hideLabel: false,
    icons: {
      right: {
        open: 'caret_up',
        closed: 'caret_down'
      }
    },
    menuItems: [
      {
        label: 'My premiums & payments history',
        hideLabel: false,
        hideItem: !isPayNowEnabled,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.premPayHistory.url
      },
      {
        label: 'Pay now',
        hideLabel: false,
        isReactRouterLink: true,
        hideItem: !isPayNowEnabled,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.payNow.url
      },
      {
        label: 'My bank details',
        hideLabel: false,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.bankDetails.url
      }
    ]
  },
  {
    label: 'Help centre',
    customCssClass: 'helpCenterMenuItem',
    hideLabel: false,
    isReactRouterLink: true,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.helpCentre.url
  }
];

export const CSPMenuStructure = (isLiveVetEnabled, isPayNowEnabled) => [
  {
    label: 'Live vet',
    customCssClass: 'liveVetMenuItem',
    hideLabel: false,
    isReactRouterLink: true,
    hideItem: !isLiveVetEnabled,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.liveVet.url
  },
  {
    label: 'Claims',
    hideLabel: false,
    icons: {
      right: {
        open: 'caret_up',
        closed: 'caret_down'
      }
    },
    menuItems: [
      {
        label: 'My claims',
        hideLabel: false,
        isReactRouterLink: true,
        url: CSPUrlsMap.myClaims.url
      },
      {
        icons: {
          left: 'claim-new'
        },
        label: 'Make a new claim',
        hideLabel: false,
        isReactRouterLink: true,
        url: CSPUrlsMap.newClaim.url
      }
    ]
  },
  {
    label: 'My pets',
    hideLabel: false,
    isReactRouterLink: true,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.myPets.url
  },
  {
    label: 'My documents',
    hideLabel: false,
    isReactRouterLink: true,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.myDocuments.url
  },
  {
    label: 'Premiums & payments',
    hideLabel: false,
    icons: {
      right: {
        open: 'caret_up',
        closed: 'caret_down'
      }
    },
    menuItems: [
      {
        label: 'My premiums & payments history',
        hideLabel: false,
        hideItem: !isPayNowEnabled,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.premPayHistory.url
      },
      {
        label: 'Pay now',
        hideLabel: false,
        isReactRouterLink: true,
        hideItem: !isPayNowEnabled,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.payNow.url
      },
      {
        label: 'My bank details',
        hideLabel: false,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.bankDetails.url
      }
    ]
  },
  {
    label: 'Help centre',
    customCssClass: 'helpCenterMenuItem',
    hideLabel: false,
    isReactRouterLink: true,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.helpCentre.url
  }
];

export const CSPMobileUserMenuStructure = (isNotificationPreferencesEnabled) => [
  {
    label: 'My profile',
    icons: {
      right: {
        open: 'caret_up',
        closed: 'caret_down'
      }
    },
    hideLabel: false,
    customCssClass: 'myProfileMainMenuItem',
    menuItems: [
      {
        label: 'Account details',
        hideLabel: false,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.accountDetails.url
      },
      {
        label: 'Vet details',
        hideLabel: false,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.vetDetails.url
      },
      {
        label: 'Notification preferences',
        hideLabel: false,
        hideItem: !isNotificationPreferencesEnabled,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.notificationPreferences.url
      }
    ]
  }
];

export const CSPUserMenuStructure = (isSsoAuthentication, isNotificationPreferencesEnabled) => [
  {
    label: 'My profile',
    hideLabel: false,
    isReactRouterLink: true,
    customCssClass: 'myProfileMainMenuItem',
    icons: {
      left: 'user1'
    },
    url: CSPUrlsMap.accountDetails.url
  },
  {
    label: 'My profile menu',
    hideLabel: true,
    customCssClass: 'myProfileSubMenuItem',
    icons: {
      right: {
        open: 'caret_up',
        closed: 'caret_down'
      }
    },
    menuItems: [
      {
        label: 'Account details',
        hideLabel: false,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.accountDetails.url
      },
      {
        label: 'Vet details',
        hideLabel: false,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.vetDetails.url
      },
      {
        label: 'Notification preferences',
        hideLabel: false,
        hideItem: !isNotificationPreferencesEnabled,
        isReactRouterLink: true,
        icons: {
          left: ''
        },
        url: CSPUrlsMap.notificationPreferences.url
      },
      {
        label: isSsoAuthentication ? 'Back to My Insurance Portal' : 'Logout',
        hideLabel: false,
        isReactRouterLink: true,
        icons: {
          left: 'logout'
        },
        url: CSPUrlsMap.logout.url
      }
    ]
  }
];

export const CSPLiteModeMenuStructure = (isLiveVetEnabled) => [
  {
    label: 'Live Vet',
    hideLabel: false,
    isReactRouterLink: true,
    hideItem: !isLiveVetEnabled,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.liveVet.url
  },
  {
    label: 'Help centre',
    hideLabel: false,
    isReactRouterLink: true,
    icons: {
      left: ''
    },
    url: CSPUrlsMap.helpCentre.url
  }
];

export const CSPLiteModeMUserMenuStructure = (isSsoAuthentication) => [
  {
    label: 'My profile',
    hideLabel: false,
    isReactRouterLink: true,
    customCssClass: 'myProfileMainMenuItem',
    icons: {
      left: 'user1'
    },
    url: '#'
  },
  {
    label: 'My profile menu',
    hideLabel: true,
    customCssClass: 'myProfileSubMenuItem',
    icons: {
      right: {
        open: 'caret_up',
        closed: 'caret_down'
      }
    },
    menuItems: [
      {
        label: isSsoAuthentication ? 'Back to My Insurance Portal' : 'Logout',
        hideLabel: false,
        isReactRouterLink: true,
        icons: {
          left: 'logout'
        },
        url: CSPUrlsMap.logout.url
      }
    ]
  }
];
